var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-container",
            [
              _c(
                "w-scroll-view",
                { style: { paddingTop: 0 }, attrs: { tag: "div" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c(
                        "w-col",
                        [
                          _vm.tabs
                            ? _c("w-tabs", {
                                staticClass: "mb",
                                attrs: { tabs: _vm.tabs },
                                model: {
                                  value: _vm.activeTab,
                                  callback: function ($$v) {
                                    _vm.activeTab = $$v
                                  },
                                  expression: "activeTab",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.activeTab == 0
                    ? _c("app-plugin-ubl-settings", {
                        attrs: { config: _vm.settings.UBL },
                        on: {
                          "save-config": function ($event) {
                            return _vm.savePluginConfig()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.activeTab == 1
                    ? _c("app-plugin-peppol-settings", {
                        attrs: { config: _vm.settings.UBL },
                        on: {
                          "save-config": function ($event) {
                            return _vm.savePluginConfig()
                          },
                          "change-tab": function ($event) {
                            _vm.activeTab = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.activeTab == 2
                    ? _c("app-plugin-ubl-email-settings", {
                        attrs: { config: _vm.settings.UBL },
                        on: {
                          "save-config": function ($event) {
                            return _vm.savePluginConfig()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.activeTab == 3
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", xl: "6" } },
                            [_c("app-ubl-overview")],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }